import { IIcon } from "./types";

const DuplicateOnOtherIcon: React.FC<IIcon> = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.26758 17.6875V5.6875C2.26758 4.03065 3.61072 2.6875 5.26758 2.6875H12.2676"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15.6338 11.0938V9.09375C15.6338 7.98918 14.7384 7.09375 13.6338 7.09375H8.63379C7.52922 7.09375 6.63379 7.98918 6.63379 9.09375V21.0938C6.63379 22.1983 7.52922 23.0938 8.63379 23.0938H13.6338C14.7384 23.0938 15.6338 22.1983 15.6338 21.0937V19.6652"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M11.7311 13.3399C11.2417 13.0839 10.6375 13.2731 10.3815 13.7625C10.1255 14.2518 10.3147 14.8561 10.8041 15.1121L11.7311 13.3399ZM22.1015 9.23937L22.6534 8.40543L20.9855 7.3017L20.4336 8.13563L22.1015 9.23937ZM14.3745 15.8511L13.911 16.7372L14.3745 15.8511ZM11.2676 14.226L10.8041 15.1121L13.911 16.7372L14.3745 15.8511L14.838 14.965L11.7311 13.3399L11.2676 14.226ZM16.9693 15.1826L17.8033 15.7345L22.1015 9.23937L21.2676 8.6875L20.4336 8.13563L16.1354 14.6308L16.9693 15.1826ZM14.3745 15.8511L13.911 16.7372C15.2736 17.45 16.9546 17.0169 17.8033 15.7345L16.9693 15.1826L16.1354 14.6308C15.8525 15.0583 15.2922 15.2026 14.838 14.965L14.3745 15.8511Z"
        fill={color}
      />
      <path
        d="M19.2676 7.6875H21.2676C21.8199 7.6875 22.2676 8.13522 22.2676 8.6875V11.6875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

DuplicateOnOtherIcon.defaultProps = {
  color: "transparent",
};

export default DuplicateOnOtherIcon;
